import { render, staticRenderFns } from "./ContentContainer.vue?vue&type=template&id=37f89032&scoped=true&"
var script = {}
import style0 from "./ContentContainer.vue?vue&type=style&index=0&id=37f89032&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f89032",
  null
  
)

export default component.exports